import { api, createQueryHandler } from './base';

export const transactionsApi = api.injectEndpoints({
  endpoints: (builder) => ({
    walletTransfer: builder.mutation({
      query: createQueryHandler('/v1/admin/transactions/wallet-transfer', 'POST'),
      invalidatesTags: ['Transaction'],
    }),
    adminTransfer: builder.mutation({
      query: createQueryHandler('/v1/admin/user/admin-transfer', 'POST'),
      invalidatesTags: ['Transaction'],
    }),
  }),
});

export const { useWalletTransferMutation, useAdminTransferMutation } = transactionsApi;
